import { useState } from "react";
import { newSurveyForm } from "../domain/survey.factories";

export default function useSurveyEditor({ duplicateDraft, notify }) {
  const duplicateQuestions = duplicateDraft && duplicateDraft.questions ? duplicateDraft.questions : [];
  const [form, setForm] = useState(() => duplicateDraft || newSurveyForm());
  const [selectedQuestionId, setSelectedQuestionId] = useState(() => duplicateQuestions.length ? duplicateQuestions[0].id : "question_001");
  const [formErrors, setFormErrors] = useState({ questions: {} });
  const [dirty, setDirty] = useState(Boolean(duplicateDraft));

  const updateForm = (nextForm) => {
    setForm(nextForm);
    setDirty(true);
    setFormErrors({ questions: {} });
  };

  const showValidation = (validation, message) => {
    setFormErrors(validation.errors);
    const firstQuestionIndex = Object.keys(validation.errors.questions || {})
      .map(Number)
      .sort((left, right) => left - right)[0];
    if (typeof firstQuestionIndex !== "undefined") {
      setSelectedQuestionId((form.questions[firstQuestionIndex] || {}).id || null);
    }
    notify(message, "warning");
  };

  return {
    form,
    setForm,
    selectedQuestionId,
    setSelectedQuestionId,
    formErrors,
    dirty,
    setDirty,
    updateForm,
    showValidation,
  };
}
